import forEach from 'lodash/forEach';
import isUndefined from 'lodash/isUndefined';
import { eachHierarchy } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { replaceCitations } from '@Utils/String';

function formatQualifier(q) {
  return q ? `{${q}}` : '';
}

function composeFieldsForFact(fact) {
  let res = '';

  forEach(fact.fields, (field, fieldIndex) => {
    res += `${field.displayName} "${field.value}"`;

    if (fieldIndex + 1 < fact.fields.length && !isUndefined(fact.fieldsLogicOperator)) {
      const qualifier = formatQualifier(fact.fieldsLogicOperatorQualifier);
      res += ` ${fact.fieldsLogicOperator}${qualifier} `;
    }
  });

  return res;
}

function composeSingleFact(factItem, fact, factIndex) {
  let part = '';

  // for wrapped facts we need to put an operator at the very beginning
  if (factIndex === 0 && factItem.logicOperator) {
    const qualifier = formatQualifier(factItem.logicOperatorQualifier);
    part += ` ${factItem.logicOperator}${qualifier} `;
  }

  // facts need to be chained by logicOperator between facts
  if (factIndex > 0 && fact.logicOperator) {
    const qualifier = formatQualifier(fact.logicOperatorQualifier);
    part += ` ${fact.logicOperator}${qualifier} `;
  }

  if (!isUndefined(fact.fields) && fact.fields.length) {
    part += composeFieldsForFact(fact);

    // if this is the last field in the outer fact list and structures exist, append outer logicOperator
    // (keeps original behaviour)
    if (factIndex + 1 === factItem.facts.length && !isUndefined(fact.logicOperator) && !isUndefined(factItem.structures)) {
      const qualifier = formatQualifier(fact.logicOperatorQualifier);
      part += ` ${fact.logicOperator}${qualifier} `;
    }
  } else if (!isUndefined(fact.advancedItems) && fact.advancedItems.length) {
    part += `"${fact.advancedItems[0].advancedExpression}"`;
  }

  return part;
}

export function _composeFactDescription(factItem, comment = '') {
  let result = comment;

  forEach(factItem.facts, (fact, factIndex) => {
    // if the node is a wrapped fact (has its own facts and no fields), recurse
    if (!isUndefined(fact.facts) && isUndefined(fact.fields)) {
      result += _composeFactDescription(fact, '');
      return; // continue to next fact
    }

    result += composeSingleFact(factItem, fact, factIndex);
  });

  return result;
}

export function defineAlertDescriptionFromFactItem(factItem, context) {
  const description = `Query Builder: in ${replaceCitations(context)} - `;
  return _composeFactDescription(factItem, description);
}

export function defineAlertStructuresFromFactItem(factItem) {
  let structures = [];

  eachHierarchy(
    factItem,
    (node) => {
      if (node.structures) {
        structures = structures.concat(node.structures);
      }
    },
    null,
    { children: 'facts' }
  );

  return structures;
}
